export default __webpack_public_path__ + "static/media/lesnik_winter_a_08.960a84ae.svg";